import { render, staticRenderFns } from "./CustomerInfoControl.vue?vue&type=template&id=041f8cc4&scoped=true"
import script from "./CustomerInfoControl.vue?vue&type=script&lang=js"
export * from "./CustomerInfoControl.vue?vue&type=script&lang=js"
import "./CustomerInfoControl.vue?vue&type=style&index=0&id=041f8cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f8cc4",
  null
  
)

export default component.exports